import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import type { CognitoUserSession } from "amazon-cognito-identity-js";

// ランダムなUUIDを生成する関数
const generateUUID = (): string => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

// APIクライアントを生成する関数
export const createApiClient = (requireAuth = true): AxiosInstance => {
  const apiClient: AxiosInstance = axios.create({
    // APIのURI
    baseURL: process.env.VUE_APP_API_BASE_URL,
    // リクエストヘッダ
    headers: {
      "Content-type": "application/json",
    },
  });

  // リクエストインターセプター
  apiClient.interceptors.request.use(
    async (config: AxiosRequestConfig) => {
      // x-api-keyを毎回生成
      if (config.headers) {
        config.headers["x-api-key"] = generateUUID();
      }

      if (requireAuth) {
        // Cognitoの参照を遅延評価
        const Cognito = await import("./cognito");
        const currentUser = Cognito.default.userPool.getCurrentUser();
        if (currentUser) {
          return new Promise((resolve, reject) => {
            currentUser.getSession((error: Error | null, session: CognitoUserSession | null) => {
              if (error) {
                reject(error);
                return;
              }
              if (!session) {
                reject(new Error("No session"));
                return;
              }
              // アクセストークンをAuthorizationヘッダーに設定
              const idToken = session.getIdToken().getJwtToken();
              if (config.headers) {
                config.headers.Authorization = `Bearer ${idToken}`;
              }
              resolve(config);
            });
          });
        }
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return apiClient;
};

// デフォルトのAPIクライアント（認証あり）
export default createApiClient();
